import * as React from 'react';
import {
  ColoredRowContainer,
  ColoredRowTextContainer,
  ColoredRowDescription,
  ColoredRowTitle,
  ColoredRowTime,
} from './ColoredRow.style';
import { RichText } from 'prismic-reactjs';

const ColoredRow = ({ rowData }) => {
  const {
    primary: {
      schedule_item_description: scheduleItemDescription,
      schedule_item_name: scheduleItemName,
      time: time,
    },
    colors: { rowColor, textColor },
    id,
  } = rowData;

  return (
    <ColoredRowContainer color={rowColor}>
      <ColoredRowTextContainer>
        <ColoredRowTime color={textColor}>{time.text}</ColoredRowTime>
        <ColoredRowTitle color={textColor}>
          {scheduleItemName.text}
        </ColoredRowTitle>
        <ColoredRowDescription>
          {scheduleItemDescription.text}
        </ColoredRowDescription>
      </ColoredRowTextContainer>
    </ColoredRowContainer>
  );
};
export default ColoredRow;
